<template>
  <h2 class="text-xl font-medium">
    <slot />
  </h2>
</template>

<script setup lang="ts"></script>
